<template>
  <div
    :class="['form-group mb-0 position-relative', customClass.containerClass]"
  >
    <label v-if="label" :for="id" :class="customClass.labelClass">{{
      label
    }}</label>
    <textarea
      :id="id"
      :type="type"
      :class="['form-control', customClass.inputClass]"
      :placeholder="placeholder"
      v-model="currentValue"
      @blur="onblur"
      @input="onchange"
      :rows="rows"
      :maxlength="charLimit"
      :disabled="disabled"
    />
    <div class="d-flex justify-content-end">
      <div style="flex: 1">
        <small class="text-danger m-0" v-if="currentError">{{
          currentError
        }}</small>
      </div>
      <small v-if="charLimit" :class="[`limit-text text-${textLimitState} m-0`]"
        >{{ currentValue.length }} / {{ charLimit }} characters</small
      >
    </div>
  </div>
</template>

<script>
import { validateEmail } from "../../utils";

export default {
  name: "InputTextarea",
  props: {
    customClass: {
      type: Object,
      default: () => ({ containerClass: "", labelClass: "", inputClass: "" }),
    },
    id: { type: String, required: true },
    value: { type: String, default: "" },
    placeholder: { type: String, default: "", required: false },
    error: { type: String, default: "", required: false },
    label: { type: String, default: "", required: false },
    type: { type: String, default: "text", required: false },
    required: { type: Boolean, default: false },
    rows: { type: Number, default: 4 },
    charLimit: { type: Number, required: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      currentError: "",
      currentValue: this.value,
    };
  },
  computed: {
    textLimitState() {
      if (this.currentValue.length >= this.charLimit) {
        return "danger";
      }
      if (this.currentValue.length + 20 >= this.charLimit) {
        return "warning";
      }
      return "muted";
    },
  },
  methods: {
    onchange(event) {
      if (event.target.value) this.currentError = "";
      this.$emit("change", event.target.value);
    },
    onblur(event) {
      if (this.required && !event.target.value) {
        this.currentError = "This field is required";
      }
      if (this.type === "email") {
        const validEmail = validateEmail(event.target.value);
        if (!validEmail) {
          this.currentError = "Email is not valid";
        }
      }
      this.$emit("blur", event.target.value);
    },
  },
  watch: {
    error(value) {
      this.currentError = value;
    },
    value(value) {
      this.currentValue = value;
    },
  },
};
</script>

<style scoped>
input {
  width: 100%;
  border-radius: 6px;
  height: 40px;
  font-size: 1rem;
}

.p-58 {
  padding-left: 58px !important;
}

label {
  color: #374151;
  font-weight: 600;
  font-size: 14px;
}

.text-muted,
input::placeholder {
  font-size: 1rem;
  color: #2e364666 !important;
  opacity: 1 !important; /* Firefox */
}

.prefix-label {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.side-label {
  position: absolute;
  bottom: 0;
  background-color: #fafafa;
  border: 1px solid #d1d9e2;
  color: #2e3646;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  font-size: 1rem;
  height: 40px;
}

.limit-text {
  font-size: 0.875rem;
}

.text-warning {
  color: #f1c40f;
}
</style>



// WEBPACK FOOTER //
// src/components/Input/InputTextarea.vue